import { Component, OnInit } from '@angular/core';
import { AuthState, IdentityAuthService } from '../_services/identity-auth.service';
import { MenuService } from '../MenuService';
import { UserService } from '../_services/user.service';
@Component({
  selector: 'home',
  templateUrl: 'home.component.html',
  standalone: false
})
export class HomeComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

  }

}